export default __webpack_public_path__ + "media/PunitGoenka.44752e28.png";